export const padding = {
  py: 3,
  px: 6,
}
